module.exports = __webpack_public_path__ + "img/option.9879cca7.png";